import Vue from "vue";
import Router from "vue-router";
import Overwatch from "./views/Overwatch.vue"
import OverwatchMap from "./views/OverwatchMap.vue"
import OverwatchNoMap from "./views/OverwatchNoMap.vue"

import SignIn from "./views/SignIn.vue"

import Settings from "./views/Settings.vue"

import Dispatch from "./views/settings/dispatch/Dispatch.vue"

import store from '@/store'


import DriverGroup from "./views/settings/driver/DriverGroup.vue"
import CreateDriverGroup from "./views/settings/driver/CreateDriverGroup.vue"
import EditDriverGroup from "./views/settings/driver/EditDriverGroup.vue"

import SystemConfiguration from "./views/settings/system_configuration/SystemConfiguration.vue"
import GeneralSettings from "./views/settings/general/GeneralSettings.vue"
import OperatingRegions from "./views/settings/general/availability/OperatingRegions.vue"
import OperatingCenter from "./views/settings/general/availability/OperatingCenter.vue"
import ZoneSettings from "./views/settings/general/zones/ZoneSettings.vue"
import FixedCosts from "./views/settings/pricing/FixedCosts.vue"
import ParkingAndTolls from "./views/settings/pricing/ParkingAndTolls.vue"
import CreateLocationAdditionalCharge from "./views/settings/pricing/CreateLocationAdditionalCharge.vue"
import LocationAdditionalCharge from "./views/settings/pricing/LocationAdditionalCharge.vue"
import PropertyAdditionalCharges from "./views/settings/pricing/PropertyAdditionalCharges.vue"
import CreatePropertyAdditionalCharge from "./views/settings/pricing/CreatePropertyAdditionalCharge.vue"
import PropertyAdditionalCharge from "./views/settings/pricing/PropertyAdditionalCharge.vue"
import FixedCost from "./views/settings/pricing/FixedCost.vue"
import CreateFixedCost from "./views/settings/pricing/CreateFixedCost.vue"
import SumUP from "./views/settings/third_party/SumUP.vue"
import Notifications from "./views/settings/messages_emails/Notifications.vue"
import WebBookings from "./views/settings/booking/WebBookings.vue"
import Cancellations from "./views/settings/booking/Cancellations.vue"
import MessagebirdNumberMasking from "./views/settings/third_party/MessagebirdNumberMasking.vue"
import AryvoConfig from "./views/settings/third_party/AryvoConfig.vue"
import TaxiChecklists from "./views/taxi/TaxiChecklists.vue"

import FlaggedBookings from "./views/settings/booking/FlaggedBookings.vue"
import PredefinedMessages from "./views/settings/booking/PredefinedMessages.vue"


import Backdate from "./views/booking/Backdate.vue"
import Book from "./views/booking/Book.vue"
import Bookings from "./views/booking/Bookings.vue"
import BookingAdditionalCharges from "./views/booking/BookingAdditionalCharges.vue"
import Calendar from "./views/calendar/Calendar.vue"
import Ratings from "./views/rating/Ratings.vue"

import AccountInvoicePolicy from "./views/account_invoicing_policy/AccountInvoicePolicy.vue"

import ExportAccountTrips from "./views/account_invoicing_policy/ExportAccountTrips.vue"

import Invoices from "./views/invoices/Invoices.vue"
import Transactions from "./views/invoices/Transactions.vue"
import DriverInvoices from "./views/invoices/DriverInvoices.vue"

import Customers from "./views/customer/Customers.vue"
import Customer from "./views/customer/Customer.vue"
import CreateCustomer from "./views/customer/CreateCustomer.vue"
import EditCustomer from "./views/customer/EditCustomer.vue"

import Drivers from "./views/driver/Drivers.vue"
import Driver from "./views/driver/Driver.vue"
import CreateDriver from "./views/driver/CreateDriver.vue"
import EditDriver from "./views/driver/EditDriver.vue"

import DriverDocuments from "./views/driver/DriverDocuments.vue"
import DriverPhotos from "./views/driver/DriverPhotos.vue"
import DriverPhotosForDriver from "./views/driver/DriverPhotosForDriver.vue"

import Taxis from "./views/taxi/Taxis.vue"
import EditTaxi from "./views/taxi/EditTaxi.vue"
import CreateTaxi from "./views/taxi/CreateTaxi.vue"

import CorporateCustomers from "./views/corporateCustomer/CorporateCustomers.vue"
import CorporateCustomer from "./views/corporateCustomer/CorporateCustomer.vue"
import CreateCorporateCustomer from "./views/corporateCustomer/CreateCorporateCustomer.vue"
import EditCorporateCustomer from "./views/corporateCustomer/EditCorporateCustomer.vue"

import AppVersions from "./views/settings/apps/Versions.vue"
import Promotions from "./views/settings/promotions/Promotions.vue"
import CreatePromotion from "./views/settings/promotions/CreatePromotion.vue"
import EditPromotion from "./views/settings/promotions/EditPromotion.vue"

import DispatchFrame from "./views/util/DispatchFrame.vue"

import Meter from "./views/settings/pricing/Meter.vue"

import RideTypes from "./views/settings/pricing/RideTypes.vue"
import CreateRideType from "./views/settings/pricing/CreateRideType.vue"
import EditRideType from "./views/settings/pricing/EditRideType.vue"

import InvoicingSettings from "./views/settings/invoicing/Invoicing.vue"

import RepeatService from "./views/repeat_service/RepeatService.vue"
import EditRepeatService from "./views/repeat_service/EditRepeatService.vue"

import LoyaltyTiers from "./views/settings/loyalty/LoyaltyTiers.vue"
import CreateLoyaltyTier from "./views/settings/loyalty/CreateLoyaltyTier.vue"
import EditLoyaltyTier from "./views/settings/loyalty/EditLoyaltyTier.vue"

import LoyaltyRewards from "./views/settings/loyalty/LoyaltyRewards.vue"
import CreateLoyaltyReward from "./views/settings/loyalty/CreateLoyaltyReward.vue"
import EditLoyaltyReward from "./views/settings/loyalty/EditLoyaltyReward.vue"

import DriverApplications from "./views/driver/DriverApplications.vue"
import DriverApplication from "./views/driver/DriverApplication.vue"
import DriversTimeline from "./views/planner/DriversTimeline.vue"

import BookingDetails from "./views/booking/BookingDetails.vue"
import NewBook from "./views/booking/NewBook.vue"
import DriversTable from './views/driver/DriversTable'
import DriverDetails from './views/driver/DriverDetails'
import CreateDriverV2 from './views/driver/CreateDriverV2'
import EditDriverV2 from './views/driver/EditDriverV2'
import FixDriverChat from '@/views/chat/FixDriverChat'
import AccountBookings from '@/views/booking/AccountBookings'
import InvoiceDetails from '@/views/invoices/InvoiceDetails'
import DriversMap from '@/views/driver/DriversMap'
import AuthLayout from '@/components/layout/AuthLayout'
import App from '@/App'
import DashboardLayout from '@/components/layout/DashboardLayout'

Vue.use(Router);


let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [ {
    path: '/signin',
    name: 'signin',
    component: SignIn,
    meta: {
      authRequired: false,
      title: 'Sign In'
    }
  }
  ],
};

let dispatchPages = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "overwatch",
      component: Overwatch
    },
    {
      path: "/overwatch_map",
      name: "overwatch_map",
      component: OverwatchMap
    },
    {
      path: "/overwatch_no_map",
      name: "overwatch_no_map",
      component: OverwatchNoMap
    },
    {
      path: '/bookings',
      name: 'bookings',
      component: Bookings,
      meta: {
        authRequired: true,
        title: 'Bookings'
      }
    }, {
      path: '/account-bookings',
      name: 'account-bookings',
      component: AccountBookings,
      meta: {
        authRequired: true,
        title: 'Bookings'
      }
    },{
      path: '/bookings/:id',
      name: 'booking-details',
      component: BookingDetails,
      meta: {
        authRequired: true,
        title: 'BookingDetails'
      }
    },{
      path: '/account-bookings/:id',
      name: 'account-booking-details',
      component: BookingDetails,
      meta: {
        authRequired: true,
        title: 'BookingDetails'
      }
    }, {
      path: '/booking_additional_charges',
      name: 'booking_additional_charges',
      component: BookingAdditionalCharges,
      meta: {
        authRequired: true,
        title: 'Booking Additional Charges'
      }
    }, {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        authRequired: true,
        title: 'Driver Calendar'
      }
    }, {
      path: '/ratings',
      name: 'ratings',
      component: Ratings,
      meta: {
        authRequired: true,
        title: 'Ratings'
      }
    }, {
      path: '/account_invoicing_policies',
      name: 'account_invoice_policies',
      component: AccountInvoicePolicy,
      meta: {
        authRequired: true,
        title: 'Account Invoice Policies'
      }
    },
    {
      path: '/export_account_trips',
      name: 'export_account_trips',
      component: ExportAccountTrips,
      meta: {
        authRequired: true,
        title: 'Export Account Trips'
      }
    }, {
      path: '/invoices',
      name: 'invoices',
      component: Invoices,
      meta: {
        authRequired: true,
        title: 'Invoices'
      }
    }, {
      path: '/invoices/:id',
      name: 'invoice_details',
      component: InvoiceDetails,
      meta: {
        authRequired: true,
        title: 'Invoices'
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions,
      meta: {
        authRequired: true,
        title: 'Transactions'
      }
    }, {
      path: '/invoices/driver/:id',
      name: 'driver_invoices',
      component: DriverInvoices,
      meta: {
        authRequired: true,
        title: 'Invoices - Driver'
      }
    },
    {
      path: '/drivers',
      name: 'drivers',
      component: Drivers,
      meta: {
        authRequired: true,
        title: 'Drivers'
      }
    },
    {
      path: '/autodispatch',
      name: 'autodispatch',
      component: DispatchFrame,
      meta: {
        authRequired: true,
        title: 'DispatchFrame'
      }
    },
    {
      path: '/drivers-map',
      name: 'drivers_map',
      component: DriversMap,
      meta: {
        authRequired: true,
        title: 'Drivers Map'
      }
    },
    {
      path: '/drivers-list',
      name: 'drivers list',
      component: DriversTable,
      meta: {
        authRequired: true,
        title: 'Drivers'
      }
    },
    {
      path: '/vehicle_photos',
      name: 'vehicle_photos',
      component: DriverPhotos,
      meta: {
        authRequired: true,
        title: 'Driver Photos'
      }
    }, {
      path: '/driver/vehicle_photos/:id',
      name: 'vehicle_photo',
      component: DriverPhotosForDriver,
      meta: {
        authRequired: true,
        title: 'Driver Photos'
      }
    },
    {
      path: '/drivers/applications',
      name: 'driver_applications',
      component: DriverApplications,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/driver-applications',
      name: 'driver-applications',
      component: DriverApplications,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/drivers/applications/:id',
      name: 'driver_application',
      component: DriverApplication,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/repeat_service',
      name: 'repeat_service',
      component: RepeatService,
      meta: {
        authRequired: true,
        title: 'RepeatService'
      }
    }, {
      path: '/repeat_service/edit/:id',
      name: 'edit_repeat_service',
      component: EditRepeatService,
      meta: {
        authRequired: true,
        title: 'EditRepeatService'
      }
    }, {
      path: '/drivers/create',
      name: 'create_driver',
      component: CreateDriver,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/drivers/:id',
      name: 'driver_details',
      component: DriverDetails,
      meta: {
        authRequired: true,
        title: 'Drivers'
      }
    },
    {
      path: '/create-driver',
      name: 'CreateDriver',
      component: CreateDriverV2,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/driver/view/:id',
      name: 'view_driver',
      component: Driver,
      redirect: '/drivers/:id',
      meta: {
        authRequired: true,
        title: 'Driver - View'
      }
    }, {
      path: '/driver_documents',
      name: 'driver_documents',
      component: DriverDocuments,
      meta: {
        authRequired: true,
        title: 'Driver Documents'
      }
    },
    {
      path: '/taxi_checklists',
      name: 'taxi_checklists',
      component: TaxiChecklists,
      meta: {
        authRequired: true,
        title: 'Taxi Checklists'
      }
    },
    {
      path: '/driver/edit/:id',
      name: 'edit_driver',
      component: EditDriver,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/drivers/edit/:id',
      name: 'EditDriver',
      component: EditDriverV2,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/taxis',
      name: 'taxis',
      component: Taxis,
      meta: {
        authRequired: true,
        title: 'Taxis'
      }
    }, {
      path: '/taxi/create',
      name: 'create_taxi',
      component: CreateTaxi,
      meta: {
        authRequired: true,
        title: 'Taxi - Create'
      },
    }, {
      path: '/taxi/edit/:id',
      name: 'edit_taxi',
      component: EditTaxi,
      meta: {
        authRequired: true,
        title: 'Taxi - Edit'
      },
    }, {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        authRequired: true,
        title: 'Settings'
      }
    }, {
      path: '/settings/dispatch',
      name: 'settings_dispatch',
      component: Dispatch,
      meta: {
        authRequired: true,
        title: 'Settings - Dispatch'
      }
    }, {
      path: '/settings/general',
      name: 'settings_general',
      component: GeneralSettings,
      meta: {
        authRequired: true,
        title: 'Settings - General'
      }
    }, {
      path: '/settings/general/zones',
      name: 'settings_general_zones',
      component: ZoneSettings,
      meta: {
        authRequired: true,
        title: 'Settings - Zones'
      }
    }, {
      path: '/settings/system_configuration',
      name: 'settings_system_configuration',
      component: SystemConfiguration,
      meta: {
        authRequired: true,
        title: 'Settings - Sys Config'
      }
    }, {
      path: "/settings/booking/flagged_bookings",
      name: 'settings_booking_flagged_bookings',
      component: FlaggedBookings,
      meta: {
        authRequired: true,
        title: 'Settings - Driver App'
      }
    }, {
      path: "/settings/booking/web",
      name: 'settings_booking_web',
      component: WebBookings,
      meta: {
        authRequired: true,
        title: 'Settings - Web Bookings'
      }
    }, {
      path: "/settings/booking/predefined_messages",
      name: 'settings_booking_predefined_messages',
      component: PredefinedMessages,
      meta: {
        authRequired: true,
        title: 'Settings - Predefined Messages'
      }
    },
    {
      path: "/settings/booking/cancellations",
      name: 'settings_booking_cancellations_messages',
      component: Cancellations,
      meta: {
        authRequired: true,
        title: 'Settings - Booking Cancellations'
      }
    }, {
      path: '/settings/general/availability/regions',
      name: 'settings_general_availability_regions',
      component: OperatingRegions,
      meta: {
        authRequired: true,
        title: 'Settings - Availability Regions'
      }
    }, {
      path: '/settings/general/availability/center',
      name: 'settings_general_availability_center',
      component: OperatingCenter,
      meta: {
        authRequired: true,
        title: 'Settings - Availability Center'
      }
    }, {
      path: '/settings/pricing/fixed_cost',
      name: 'settings_pricing_fixed_cost',
      component: FixedCosts,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Fixed Cost'
      }
    },
    {
      path: '/settings/pricing/parking_and_tolls',
      name: 'settings_parking_and_tolls',
      component: ParkingAndTolls,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Parking and Tolls'
      }
    },
    {
      path: '/settings/pricing/parking_and_tolls/create',
      name: 'settings_parking_and_tolls_create',
      component: CreateLocationAdditionalCharge,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Parking and Tolls - Create'
      }
    },
    {
      path: '/settings/pricing/parking_and_tolls/:id',
      name: 'settings_parking_and_tolls_view',
      component: LocationAdditionalCharge,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Parking and Tolls - Edit'
      }
    },
    {
      path: '/settings/pricing/property_additional_charges',
      name: 'settings_property_additional_charges',
      component: PropertyAdditionalCharges,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Property Additional Charges'
      }
    },
    {
      path: '/settings/pricing/property_additional_charges/create',
      name: 'settings_property_additional_charges_create',
      component: CreatePropertyAdditionalCharge,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Property Additional Charges - Create'
      }
    },
    {
      path: '/settings/pricing/property_additional_charges/:id',
      name: 'settings_property_additional_charges_view',
      component: PropertyAdditionalCharge,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Property Additional Charges - Edit'
      }
    },
    {
      path: '/settings/pricing/fixed_cost/create',
      name: 'settings_pricing_fixed_cost_create',
      component: CreateFixedCost,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Fixed Cost'
      }
    }, {
      path: '/settings/pricing/fixed_cost/:id',
      name: 'settings_pricing_fixed_cost_fixed_cost',
      component: FixedCost,
      meta: {
        authRequired: true,
        title: 'Settings - Pricing - Fixed Cost'
      }
    }, {
      path: '/settings/third_party/sumup',
      name: 'settings_third_party_sumup',
      component: SumUP,
      meta: {
        authRequired: true,
        title: 'Settings - Third Party - SumUp'
      }
    }, {
      path: '/settings/third_party/messagebird_number_masking',
      name: 'settings_messagebird_number_masking',
      component: MessagebirdNumberMasking,
      meta: {
        authRequired: true,
        title: 'Settings - Third Party - MessageBird'
      }
    }, {
      path: '/settings/third_party/aryvo',
      name: 'settings_aryvo',
      component: AryvoConfig,
      meta: {
        authRequired: true,
        title: 'Settings - Aryvo'
      }
    }, {
      path: '/settings/messages_emails/notifications',
      name: 'settings_messages_emails_notifications',
      component: Notifications,
      meta: {
        authRequired: true,
        title: 'Settings - Notifications'
      }
    }, {
      path: '/customers',
      name: 'customers',
      component: Customers,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/customers/create',
      name: 'create_customer',
      component: CreateCustomer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/customer/edit/:id',
      name: 'edit_customer',
      component: EditCustomer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/customer/view/:id',
      name: 'view_driver_customer',
      component: Customer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/corporateCustomers',
      name: 'corporate_customers',
      component: CorporateCustomers,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/corporateCustomers/create',
      name: 'create_corporate_customer',
      component: CreateCorporateCustomer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/corporateCustomer/edit/:id',
      name: 'edit_corporate_customer',
      component: EditCorporateCustomer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/corporateCustomer/view/:id',
      name: 'view_corporate_customer',
      component: CorporateCustomer,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/driver_group',
      name: 'driver_groups',
      component: DriverGroup,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/driver_group/create',
      name: 'driver_group_create',
      component: CreateDriverGroup,
      meta: {
        authRequired: true,
      }
    },{
      path: '/settings/driver_group/edit/:id',
      name: 'driver_group_edit',
      component: EditDriverGroup,
      meta: {
        authRequired: true,
      }
    },{
      path: '/settings/apps/versions',
      name: 'app_versions',
      component: AppVersions,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/promotions',
      name: 'promotions',
      component: Promotions,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/promotions/create',
      name: 'create_promotion',
      component: CreatePromotion,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/promotion/edit/:id',
      name: 'edit_promotion',
      component: EditPromotion,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/pricing/ride_types/',
      name: 'ride_types',
      component: RideTypes,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/settings/pricing/ride_types/create',
      name: 'create_ride_type',
      component: CreateRideType,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/pricing/ride_types/edit/:id',
      name: 'edit_ride_type',
      component: EditRideType,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/ride_type_edit/:id',
      name: 'edit_ride_type_new',
      component: EditRideType,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/invoicing',
      name: 'settings_invoicing',
      component: InvoicingSettings,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/book',
      name: 'book',
      component: Book,
      meta: {
        authRequired: true,
      }
    }, {
      path: '/new-booking',
      name: 'new-booking',
      component: NewBook,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/backdate',
      name: 'backdate',
      component: Backdate,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty_tiers',
      name: 'settings_loyalty_tiers',
      component: LoyaltyTiers,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty/loyalty_tiers/create',
      name: 'settings_loyalty_tiers_create',
      component: CreateLoyaltyTier,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty_tiers/edit/:id',
      name: 'settings_loyalty_tiers_edit',
      component: EditLoyaltyTier,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty_rewards',
      name: 'settings_loyalty_rewards',
      component: LoyaltyRewards,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty_rewards/create',
      name: 'settings_loyalty_rewards_create',
      component: CreateLoyaltyReward,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/settings/loyalty_rewards/edit/:id',
      name: 'settings_loyalty_rewards_edit',
      component: EditLoyaltyReward,
      meta: {
        authRequired: true,
      }
    },
    {
      path:  "/settings/pricing/meter",
      name: 'settings_meter',
      component: Meter,
      meta: {
        authRequired: true,
        title: 'Settings - Meter'
      }
    },
    {
      path: '/planner/timeline',
      name: 'drivers_timeline',
      component: DriversTimeline,
      meta: {
        authRequired: true,
      }
    },
    {
      path: '/fix_chat',
      name: 'fix_chat',
      component: FixDriverChat,
      meta: {
        authRequired: true,
      }
    },
  ],
};




const router =  new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
      dispatchPages,
      authPages
  ]
});



export default router;
